import React from "react";
import "./Top_Filter_Div.css";
import Breadcrumb_comp from "../../common_components/breadcrumb-comp/Breadcrumb_comp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faList,
  faSortDown,
  faTableCells,
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Tab } from "react-bootstrap";
import Sort_by_Modal from "../../common_components/common_modal/sort_by_modal/Sort_by_Modal";

const Top_Filter_Div = ({
  subTitle,
  selectedOption,
  setSelectedOption,
  ...props
}) => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: props?.pageTitle, link: "", isActive: true },
    { label: subTitle, link: "", isActive: true },
  ];

  const [modalShow, setModalShow] = React.useState(false);

  return (
    <div className="top_filter_div">
      <div className="container">
        <div className="two_divs">
          <div className="breadcrump_div">
            <Breadcrumb_comp breadcrumbs={breadcrumbs} />
          </div>
          <div className="right_side_div">
            <div className="sort_div">
              <img
                src="/assets/images/other/sort.png"
                className="sort_img"
                onClick={() => {
                  setModalShow(true);
                }}
              />
              <p
                className="sort_text"
                onClick={() => {
                  setModalShow(true);
                }}
              >
                Sort
              </p>
              <FontAwesomeIcon
                icon={faSortDown}
                className="sort_icon"
                onClick={() => {
                  setModalShow(true);
                }}
              />

              {/* <Nav
                                variant="pills"
                                className="filter_tab_holder"
                            >
                                <Nav.Item>
                                    <Nav.Link eventKey="Grid">
                                        <section className="Grid_List_Holder" >
                                            <FontAwesomeIcon className="btn_icon" icon={faTableCells} />
                                        </section>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="List">
                                        <section className="Grid_List_Holder" >
                                            <FontAwesomeIcon className="btn_icon" icon={faList} />
                                        </section>
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav> */}
            </div>
          </div>
        </div>
      </div>

      <Sort_by_Modal
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </div>
  );
};

export default Top_Filter_Div;
